// Generated by scripts/migrate/gen-from-live.py from https://www.dietz.eu/en/spring-labelling/
// Source of truth is the LIVE page, not the original markdown scrape
// (which was incomplete: this content type was missed entirely, and
// several pages were captured as summaries rather than verbatim copy).
import type { PageEntry } from "@/content/schema";

export const springLabellingEN: PageEntry = {
  id: "post.federkennzeichnung",
  locale: "en",
  slug: "spring-labelling",
  seo: {
    title: "Glossary: Spring labelling explained simply | Dietz GmbH",
    description: "Spring labelling involves the marking or labelling of springs to provide information about their specifications, origin or areas of application. Typical labelling may include sprin",
  },
  type: "post",
  h1: "Glossary: Spring labelling explained simply",
  intro: "Spring labelling involves the marking or labelling of springs to provide information about their specifications, origin or areas of application. Typical labelling may include spring constant, material type, date of manufacture or manufacturer information. Spring labelling is important for the identification and tracking of springs during their life cycle. This facilitates maintenance work, quality control and compliance with standards. Clear and precise labelling is therefore crucial to ensure the correct use and handling of springs in various applications.",
  blocks: [

  ],
};
